import loadable from "@loadable/component";
import ErrorBoundary from "@Components/ErrorBoundary";
import loadData from "./data";
import FullPageLoader from "@Components/FullPageLoader";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router";
import getNewsHomeData from "./data/getNewsHomeData";
import type { AppState } from "@Store/index";

// eslint-disable-next-line import/no-unresolved
const NewsHome = loadable(() => import("./NewsHome"), {
  fallback: <FullPageLoader />,
});

export default (props: any): JSX.Element => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { readyStatus, homeFeaturedNews } = useSelector((state: AppState) => state.newsHomeData);

  useEffect(() => {
    if (
      readyStatus === "invalid" ||
      (readyStatus !== "request" && readyStatus !== "failure" && homeFeaturedNews.length === 0)
    ) {
      dispatch(getNewsHomeData({ staticContext: props?.staticContext }));
    }
  }, [dispatch, readyStatus, homeFeaturedNews.length, location.pathname]);

  return (
    <ErrorBoundary>
      <NewsHome {...props} />
    </ErrorBoundary>
  );
};

export { NewsHome as PreFetchNewsHome };
export { loadData };
